import React from 'react';

// Progress for a direct-to-S3 upload. A 250MB clip behind a bare spinner looks
// frozen, so people re-click or give up on it. `percent` is 0-100, -1 when the
// browser cannot report a total (indeterminate), null when nothing is uploading.
export function UploadProgress({ percent, label = 'Uploading…' }: { percent: number | null; label?: string }) {
  if (percent === null) return null;
  const known = percent >= 0;
  return (
    <div style={{ padding: '10px 12px', borderRadius: 'var(--hj-r-sm)', border: '1px solid var(--hj-beige-line)', background: '#fff' }}>
      <div className="flex items-center justify-between" style={{ marginBottom: 6 }}>
        <span style={{ fontSize: 12, fontWeight: 600, color: 'var(--hj-beige-ink)' }}>
          {percent === 100 ? 'Finishing up…' : label}
        </span>
        {known && (
          <span style={{ fontSize: 12, fontWeight: 700, color: 'var(--hj-beige-ink)', fontVariantNumeric: 'tabular-nums' }}>{percent}%</span>
        )}
      </div>
      <div style={{ height: 6, borderRadius: 999, background: 'var(--hj-beige-deep)', overflow: 'hidden' }}>
        <div
          style={{
            height: '100%',
            width: known ? `${percent}%` : '100%',
            background: 'var(--hj-beige-ink)',
            borderRadius: 999,
            transition: 'width 0.2s ease',
            opacity: known ? 1 : 0.35,
          }}
        />
      </div>
      <p className="m-0" style={{ marginTop: 6, fontSize: 11.5, color: 'var(--hj-beige-ink-2)' }}>Keep this tab open until it finishes.</p>
    </div>
  );
}
